import http from "./httpService";

const esriServer = "https://services1.arcgis.com/";

export function getYears(publisherID, layerName) {
  return http.get(
    esriServer +
      publisherID +
      "/arcgis/rest/services/" +
      layerName +
      "/FeatureServer/0/query?where=STATE+is+not+null&objectIds=&time=&geometry=&geometryType=esriGeometryEnvelope&inSR=&spatialRel=esriSpatialRelIntersects&resultType=none&distance=0.0&units=esriSRUnit_Meter&relationParam=&returnGeodetic=false&outFields=SURVEY_YEA&returnGeometry=false&featureEncoding=esriDefault&multipatchOption=xyFootprint&maxAllowableOffset=&geometryPrecision=&outSR=&defaultSR=&datumTransformation=&applyVCSProjection=false&returnIdsOnly=false&returnUniqueIdsOnly=false&returnCountOnly=false&returnExtentOnly=false&returnQueryGeometry=false&returnDistinctValues=true&cacheHint=false&orderByFields=SURVEY_YEA&groupByFieldsForStatistics=SURVEY_YEA&outStatistics=&having=&resultOffset=&resultRecordCount=&returnZ=false&returnM=false&returnExceededLimitFeatures=true&quantizationParameters=&sqlFormat=none&f=pjson&token="
  );
}

export function getHostsByState(publisherID, layerName, state) {
  if (state === "All States") {
    return http.get(
      esriServer +
        publisherID +
        "/arcgis/rest/services/" +
        layerName +
        "/FeatureServer/0/query?where=STATE+is+not+null&objectIds=&time=&geometry=&geometryType=esriGeometryEnvelope&inSR=&spatialRel=esriSpatialRelIntersects&resultType=none&distance=0.0&units=esriSRUnit_Meter&relationParam=&returnGeodetic=false&outFields=Host_Categ&returnGeometry=false&featureEncoding=esriDefault&multipatchOption=xyFootprint&maxAllowableOffset=&geometryPrecision=&outSR=&defaultSR=&datumTransformation=&applyVCSProjection=false&returnIdsOnly=false&returnUniqueIdsOnly=false&returnCountOnly=false&returnExtentOnly=false&returnQueryGeometry=false&returnDistinctValues=true&cacheHint=false&orderByFields=Host_Categ&groupByFieldsForStatistics=Host_Categ&outStatistics=&having=&resultOffset=&resultRecordCount=&returnZ=false&returnM=false&returnExceededLimitFeatures=true&quantizationParameters=&sqlFormat=none&f=pjson&token="
    );
  } else {
    return http.get(
      esriServer +
        publisherID +
        "/arcgis/rest/services/" +
        layerName +
        "/FeatureServer/0/query?where=STATE+%3D+%27" +
        state +
        "%27&objectIds=&time=&geometry=&geometryType=esriGeometryEnvelope&inSR=&spatialRel=esriSpatialRelIntersects&resultType=none&distance=0.0&units=esriSRUnit_Meter&relationParam=&returnGeodetic=false&outFields=Host_Categ&returnGeometry=false&featureEncoding=esriDefault&multipatchOption=xyFootprint&maxAllowableOffset=&geometryPrecision=&outSR=&defaultSR=&datumTransformation=&applyVCSProjection=false&returnIdsOnly=false&returnUniqueIdsOnly=false&returnCountOnly=false&returnExtentOnly=false&returnQueryGeometry=false&returnDistinctValues=true&cacheHint=false&orderByFields=Host_Categ&groupByFieldsForStatistics=Host_Categ&outStatistics=&having=&resultOffset=&resultRecordCount=&returnZ=false&returnM=false&returnExceededLimitFeatures=true&quantizationParameters=&sqlFormat=none&f=pjson&token="
    );
  }
}

export function getPestsByStateAndHost(publisherID, layerName, state, host) {
  let query =
    esriServer +
    publisherID +
    "/arcgis/rest/services/" +
    layerName +
    "/FeatureServer/0/query?where=";
  if (state === "All States") {
    query += "STATE+is+not+null";
  } else {
    query += "STATE+%3D%27" + state + "%27";
  }
  if (host !== "All Trees") {
    query += "+And+Host_Categ+%3D+%27" + host.replace(" ", "+") + "%27";
  }
  query +=
    "&objectIds=&time=&geometry=&geometryType=esriGeometryEnvelope&inSR=&spatialRel=esriSpatialRelIntersects&resultType=none&distance=0.0&units=esriSRUnit_Meter&relationParam=&returnGeodetic=false&outFields=DCA_CODE%2CDCA_COMMON&returnGeometry=false&featureEncoding=esriDefault&multipatchOption=xyFootprint&maxAllowableOffset=&geometryPrecision=&outSR=&defaultSR=&datumTransformation=&applyVCSProjection=false&returnIdsOnly=false&returnUniqueIdsOnly=false&returnCountOnly=false&returnExtentOnly=false&returnQueryGeometry=false&returnDistinctValues=true&cacheHint=false&orderByFields=DCA_COMMON&groupByFieldsForStatistics=DCA_COMMON&outStatistics=&having=&resultOffset=&resultRecordCount=&returnZ=false&returnM=false&returnExceededLimitFeatures=true&quantizationParameters=&sqlFormat=none&f=pjson&token=";
  return http.get(query);
}
